import { LockIcon } from '../icons/LockIcon'

/* ─── "Requires subscription for …" badge on Preview MCP products ───
   Shared by MCP Config and MCP Analytics. The label is per-product and passed
   in, since the prototype names the product it needs
   ("Requires subscription for Mambu Payments").
   Prototype: agent-studio.html:5783 (analytics), :5477 (config). */

export function RequiresSubscriptionBadge({ label }: { label: string }) {
  return (
    <span className="req-badge" style={{ marginTop: 0 }}>
      <LockIcon size={13} />
      {label}
    </span>
  )
}
